import CustomHeaderRowRenderer from './CustomHeaderRowRenderer';

export default CustomHeaderRowRenderer;
